import axios from 'axios'
import auth from '../utils/auth'
import cfg from '../utils/config'

const getMonitorados = async () => {
    const userInfo = auth.getUserInfo()

    const requestURL = cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + '/monitorado/'
    const config = { headers: { Authorization: `Bearer ${auth.getToken()}` } }

    try {
        const response = await axios.get(requestURL, config)
        return response.data.results
    } catch (error) {
        console.error('Erro ao buscar monitorados:', error)
        return []
    }
}
const getMonitorado = async (idMonitorado) => {
    const userInfo = auth.getUserInfo()

    const requestURL = cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + `/monitorado/${idMonitorado}/`
    const config = { headers: { Authorization: `Bearer ${auth.getToken()}` } }

    try {
        const response = await axios.get(requestURL, config)
        return response.data
    } catch (error) {
        console.error('Erro ao buscar monitorado:', error)
        return {}
    }
}

const getMonitoradosByCliente = async (id_cliente) => {
    const userInfo = auth.getUserInfo()

    const requestURL =
        cfg.base_api_url +
        cfg.api_v2 +
        '/' +
        userInfo.empresa +
        '/monitorado/filtro/'

    const payload = {
        cliente_id: Number(id_cliente) ?? userInfo.id
    }

    const config = {
        headers: {
            Authorization: `Bearer ${auth.getToken()}`
        }
    }

    try {
        const response = await axios.post(requestURL, payload, config)

        return response.data.map((c) => ({
            value: c.id,
            label: c.nome
        }))

    } catch (error) {
        console.error('Erro ao buscar monitorados por cliente:', error)
        return []
    }
}


export { getMonitorados, getMonitorado, getMonitoradosByCliente }